var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Animation',{attrs:{"duration":{ enter: 350, leave: 200 },"enter":"fadeIn","leave":"fadeOut","appear":""}},[_c('div',{staticClass:"dialog-backdrop"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }